<script>
    import { createEventDispatcher } from 'svelte';
    import { network } from '../stores.js';

    export let idKontr;

    const dispatch = createEventDispatcher();

    let nameKontakt = '';
    let telefonKontakt = '';
    let isSaving = false;
    let error = '';

    async function handleSave() {
        if (!nameKontakt.trim()) {
            error = 'Укажите имя контакта';
            return;
        }
        error = '';
        isSaving = true;
        try {
            const result = await network.fetch_proxy(
                `EXEC [addKontakts]
                        @idKontr = ${+idKontr},
                        @nameKontakt =N'${nameKontakt.trim().replace(/'/g, "''")}',
                        @fioKontakt ='',
                        @adresKontakt ='',
                        @telefonKontakt = N'${telefonKontakt.trim().replace(/'/g, "''")}',
                        @shemaKontakt =0,
                        @other1Kontakt ='',
                        @other2Kontakt ='',
                        @actualnost   = 1`
            );
            const newId = result?.idKontakt ?? result?.[0]?.idKontakt ?? null;
            dispatch('created', {
                idKontakt: newId,
                nameKontakt: nameKontakt.trim(),
                telefonKontakt: telefonKontakt.trim()
            });
        } catch (e) {
            error = 'Не удалось создать контакт. Попробуйте ещё раз.';
        } finally {
            isSaving = false;
        }
    }

    function handleClose() {
        dispatch('close');
    }
</script>

<div class="modal-backdrop" on:click={handleClose}>
    <div class="modal-content" on:click|stopPropagation>
        <h3>Новый контакт</h3>

        {#if error}
            <div class="modal-error">{error}</div>
        {/if}

        <label class="form-label" for="contactName">Имя</label>
        <input
                id="contactName"
                type="text"
                class="form-control"
                bind:value={nameKontakt}
                placeholder="Имя контакта"
        />

        <label class="form-label" for="contactTel">Телефон</label>
        <input
                id="contactTel"
                type="tel"
                class="form-control"
                bind:value={telefonKontakt}
                placeholder="+7..."
        />

        <div class="modal-actions">
            <button type="button" class="btn btn-outline-secondary" on:click={handleClose} disabled={isSaving}>
                Отмена
            </button>
            <button type="button" class="btn btn-primary" on:click={handleSave} disabled={isSaving}>
                {isSaving ? 'Сохранение...' : 'Создать'}
            </button>
        </div>
    </div>
</div>

<style>
    .modal-backdrop {
        position: fixed;
        inset: 0;
        background: rgba(0,0,0,0.45);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 1000;
    }
    .modal-content {
        background: #fff;
        border-radius: 14px;
        padding: 20px;
        width: 90%;
        max-width: 360px;
        display: flex;
        flex-direction: column;
        gap: 10px;
    }
    .modal-error {
        background: #fff4f4;
        color: #b42318;
        border: 1px solid #f0c7c7;
        border-radius: 10px;
        padding: 8px 12px;
        font-size: 13px;
    }
    .form-control {
        border-radius: 10px;
        border: 1px solid #d8dde3;
        padding: 10px 12px;
        min-height: 44px;
    }
    .modal-actions {
        display: flex;
        justify-content: flex-end;
        gap: 8px;
        margin-top: 8px;
    }
</style>